<div class="ng-container">
    <img src="/x-assets/img/icons/quality-mark.svg"  alt=""/>
    <span>{{ messages.recommendedText }}</span>
</div>
